import "./customTooltip.scss";

export default function CustomTooltip(props) {
  if (!props.active || !props.payload?.length) return null;

  const color = props.payload[0].payload.fill; // 🎯 cor da barra

  return (
    <div
      className="customtooltip"
      style={{
        background: "var(--color-002)",
        color: "var(--color-018)",
        padding: "4px 8px",
        borderRadius: "5px",
        display: "flex",
        gap: "10px",
      }}
    >
      {!props.hideCaixinha && (
        <span style={{ background: color }} className="caixinha"></span>
      )}
      {!props.hideLabel && <p style={{ margin: 0 }}>{props.label}</p>}
      {props.payload.map((item, index) => (
        <p key={index} style={{ margin: 0 }}>
          {!props.hideName && <span>{item.name}: </span>}
          {item.value}
        </p>
      ))}
    </div>
  );
}
CustomTooltip.defaultProps = {
  hideName: true,
  hideLabel: false,
  hideCaixinha: false,
};
